import type { ModalAction } from 'components/ui/modals/Modal/index.js';

import type { HelpdeskModalState } from './Helpdesk.types.js';

export const getHelpdeskDialogActions = ({
  state,
  onClose,
}: {
  state: HelpdeskModalState;
  onClose: () => void;
}): ModalAction[] => {
  switch (state) {
    case 'Success':
      return [
        {
          title: 'Close',
          buttonProps: {
            color: 'secondary',
            variant: 'outlined',
          },
          onClick: onClose,
        },
      ];
    default:
      return [];
  }
};
